import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface Props {
  title: string;
  price?: string;
  isCompleted: boolean;
}

const formatPrice = (price?: string): string | null => {
  if (!price) return null;

  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) return price;

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericPrice);
};

const ProjectDetailsHeader = ({ title, price, isCompleted }: Props) => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col mb-[3.5rem] overflow-hidden"
    >
      {isCompleted && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="px-[1.6rem] py-[0.8rem] bg-primary rounded-[10rem] max-w-[15rem] mb-[1.2rem]"
        >
          <p className="p-small whitespace-nowrap">Project Completed</p>
        </motion.div>
      )}

      <motion.h1
        initial={{ opacity: 0, clipPath: "inset(0 100% 0 0)" }}
        animate={
          inView
            ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
            : { opacity: 0, clipPath: "inset(0 100% 0 0)" }
        }
        transition={{ duration: 0.7, delay: 0.3 }}
        className="h5 text-white mb-[3.5rem]"
      >
        {title}
      </motion.h1>

      {price && (
        <motion.h4
          initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
          animate={
            inView
              ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
              : { opacity: 0, clipPath: "inset(0 0 0 100%)" }
          }
          transition={{ duration: 0.7, delay: 0.4 }}
          className="text-white"
        >
          {price ? `GDV: ${formatPrice(price)}` : "Price not available"}
        </motion.h4>
      )}
    </motion.div>
  );
};

export default ProjectDetailsHeader;
